"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PimScheduleBulkUpdateModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var main_1 = require("../../../../../../reducers/slices/main");
var PimScheduleBulkUpdateModal = function (_a) {
    var onSubmit = _a.onSubmit;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_2.useState)(), scheduleTime = _b[0], setScheduleTime = _b[1];
    var _c = (0, react_2.useState)("12:00"), selectedTime = _c[0], setSelectedTime = _c[1];
    var handleContinue = function () {
        if (!!scheduleTime && !!selectedTime) {
            onSubmit(scheduleTime);
        }
        else {
            dispatch((0, main_1.setMessageModal)({
                title: "Error!",
                messages: ["Please select a schedule time."],
            }));
        }
    };
    // Generate time options in 30-minute intervals
    var generateTimeOptions = function () {
        var times = [];
        for (var hour = 0; hour < 24; hour++) {
            for (var _i = 0, _a = [0, 30]; _i < _a.length; _i++) {
                var minute = _a[_i];
                var formattedHour = hour.toString().padStart(2, "0");
                var formattedMinute = minute.toString().padStart(2, "0");
                times.push("".concat(formattedHour, ":").concat(formattedMinute));
            }
        }
        return times;
    };
    var timeOptions = generateTimeOptions();
    var handleTimeChange = function (value) {
        setSelectedTime(value);
        if (value) {
            var _a = value.split(":").map(Number), hours = _a[0], minutes = _a[1];
            var newDate = new Date(scheduleTime);
            newDate.setHours(hours, minutes);
            setScheduleTime(newDate);
        }
    };
    var handleDateChange = function (date) {
        if (date) {
            var newDate = new Date(date);
            var _a = selectedTime.split(":").map(Number), hours = _a[0], minutes = _a[1];
            newDate.setHours(hours, minutes);
            setScheduleTime(newDate);
        }
    };
    var onCancel = function () {
        dispatch((0, main_1.setContentModal)(null));
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(react_1.DatePicker, { label: "Schedule Time", onChange: function (date) { return handleDateChange(date); } }), (0, jsx_runtime_1.jsx)(react_1.Select, __assign({ label: "Schedule Time", value: selectedTime, onChange: function (e) { return handleTimeChange(e.target.value); }, className: "w-full" }, { children: timeOptions.map(function (time) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, __assign({ value: time }, { children: time }), time)); }) })), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Selected Date & Time", value: scheduleTime === null || scheduleTime === void 0 ? void 0 : scheduleTime.toLocaleString(), isReadOnly: true, className: "w-full" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-end gap-2" }, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, __assign({ color: "danger", variant: "light", onClick: onCancel }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(react_1.Button, __assign({ color: "primary", onClick: handleContinue }, { children: "Continue" }))] }))] })));
};
exports.PimScheduleBulkUpdateModal = PimScheduleBulkUpdateModal;
